<template>
  <v-dialog v-model="dialog" max-width="800" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex align-items-center justify-content-center">
        <v-btn
          color="#1E1E1E"
          rounded
          outlined
          small
          class="ml-5 text-uppercase"
          v-bind="attrs"
          v-on="on"
        >
          Edit
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>Edit Device Configuration</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form v-if="config">
          <div class="form-row d-flex align-items-end">
            <div
              class="col-md-6"
              v-for="(value, key, index) in config"
              :key="index"
              style="padding-right: 15px;padding-left: 15px;"
            >
              <v-text-field
                required
                :name="key"
                :label="key"
                outlined
                v-bind:value="value"
                v-model="config[key]"
              >
                {{ value }}
              </v-text-field>
            </div>
          </div>
        </v-form>
        <v-divider></v-divider>
        <v-card-actions
          class="d-flex align-items-center justify-content-center"
        >
          <v-btn color="#717C7D" text @click="dialog = false">{{
            $t("lang.location_form.btn_cancel")
          }}</v-btn>
          <v-btn
            color="#FF5800"
            text
            @click="submitForm"
            :disabled="state === 'OFF'"
            >{{ $t("lang.admin.device_form.btn_done") }}</v-btn
          >
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["data", "id", "state"],
  data() {
    return {
      config: [],
      dialog: false,
      errorLabels: {
        field: this.$t("All field are require")
      }
    };
  },
  mounted() {
    try {
      this.config = this.data.config;
    } catch (error) {
      this.errors.push(this.errorLabels.notFound);
    }
  },
  methods: {
    async submitForm() {
      let input = Object.assign({}, this.config);
      try {
        let response = await this.$api.nms.update_device_conf(this.id, {
          config: this.config,
          device: this.data.device,
          version: this.data.version
        });
        console.log("res", response);
        this.dialog = false;
      } catch (error) {
        this.errors.push(this.errorLabels.failed);
        console.error(error);
      }
      // }
    },
    validate() {
      this.errors = [];
      let keys = Object.keys(this.config);
      for (let i = 0; i < keys.length; i++) {
        // eslint-disable-next-line no-undef
        let val = obj[keys[i]];
        if (!val) {
          this.errors.push(this.errorLabels.field);
          return false;
        }
      }
      return true;
    },
    stateName(state) {
      if (state === "ON") {
        return this.$t("lang.admin.online");
      } else if (state === "OFF") {
        return this.$t("lang.admin.offline");
      } else {
        return "";
      }
    },
    stateNumber(state) {
      if (state === "ON") {
        return 3;
      } else if (state === "OFF") {
        return 2;
      } else {
        return "";
      }
    }
  }
};
</script>
<style></style>
